import { defineStore } from 'pinia'
import SettingFormatFileService from "@/services/setting-format-file.service.ts";
import ErrorMessageService from "@/services/error-message.service.ts";
export const useSettingFormatFileStore = defineStore('settingFormatFile', {
    state: () => {
        return {
            settingFormat: [],
            paginate: {},
            lastPage: 1,
            fields: []
        }
    },
    persist: true,
    actions: {
        async getListSettingFormatFile(url, params) {
            try {
                const res = await SettingFormatFileService.getListSettingFormatFile(url, params)
                this.settingFormat = res.data.data
                this.paginate = res.data.meta
                this.lastPage = res.data.meta.page
            } catch (e) {
                return null
            }
        },
        async getSettingFormatFile(url, params) {
            try {
                const res = await SettingFormatFileService.getSettingFormatFile(url, params)
                this.settingFormat = res.data
            } catch (e) {
                return null
            }
        },
        async getListFormatFileWithoutLimit(url, params) {
            try {
                const res = await SettingFormatFileService.getListFormatFileWithoutLimit(url, params)
                this.settingFormat = res.data
            } catch (e) {
                return null
            }
        },
        async getListField(url, params) {
            try {
                const res = await SettingFormatFileService.getListFields(url, params)
                this.fields = res.data
            } catch (e) {
                return null
            }
        },
        async createOrUpdateSettingFile(url, params) {
            try {
                const res = await SettingFormatFileService.createOrUpdateSettingFile(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },
        async enableFormatFile(url, params) {
            try {
                const res = await SettingFormatFileService.enableFormatFile(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },
        async downloadFormatFile(url, params) {
            try {
                const res = await SettingFormatFileService.downloadFormatFile(url, params)
                return res;
            } catch (e) {
                return null
            }
        },
        async exportFile(url, params) {
            try {
                const res = await SettingFormatFileService.exportFile(url, params)
                return res;
            } catch (e) {
                return null
            }
        },
        async importFile(url, params) {
            try {
                const res = await SettingFormatFileService.importFile(url, params)
                return res;
            } catch (e) {
                return e
            }
        },
    }
})
